import {
  AfterViewInit,
  Component,
  EnvironmentInjector,
  inject,
  signal,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

import { CwButton, CwDialog } from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';
import { DialogBase } from '@shared/components/dialogs/dialog-base';
import { DialogOptions } from '@shared/interfaces/dialogs/dialog-options.interface';
import { DialogService } from '@shared/service/dialog/dialog.service';

@Component({
  selector: 'app-dialog-host',
  templateUrl: './dialog-host.component.html',
  styleUrl: './dialog-host.component.sass',
  imports: [CwButton, CwDialog, TranslocoDirective]
})
export class DialogHostComponent implements AfterViewInit {
  readonly dialogData = signal<DialogOptions | null>(null);

  protected readonly open = signal(false);

  @ViewChild('componentContainer', { read: ViewContainerRef, static: false })
  componentContainer: ViewContainerRef;

  private environmentInjector = inject(EnvironmentInjector);
  private dialogService = inject(DialogService);

  public ngAfterViewInit() {
    this.dialogService.dialog$.subscribe(([component, data]) => {
      this.dialogData.set(data);
      this.renderComponent(component);
      this.open.set(!!data);
    });
  }

  protected onConfirm() {
    this.handleDialogClose(true);
  }

  protected onCancel() {
    this.handleDialogClose(false);
  }

  private handleDialogClose(returnValue: boolean): void {
    this.componentContainer.clear();
    this.open.set(false);
    this.dialogService.closeDialog(returnValue);
  }

  private renderComponent(component: Type<DialogBase>) {
    const dialogData = this.dialogData();
    if (!dialogData) return;
    const componentRef = this.componentContainer.createComponent(component, {
      environmentInjector: this.environmentInjector
    });

    componentRef.instance.data = dialogData.data;
    componentRef.changeDetectorRef.detectChanges();
  }
}
